import Button from '@/components/DesignLibrary/Button';
import CheckCircle from '@/components/Icons/CheckCircle';
import RadioButton from '@components/Icons/RadioButton';
import Circle from '@components/Icons/Circle';
import Buttons from '@/components/Buttons';

import s from './UploadBankStatementModal.module.scss';

type Props = {
  uploadType: 'plaid' | 'manual';
  onSelectType: (type: 'plaid' | 'manual') => void;
  onClickNext: () => void;
};

const ChooseType: React.FC<Props> = ({ uploadType, onClickNext, onSelectType }) => (
  <div className={s.container}>
    <h1 className={s.chooseTitle}>How do you want to provide Bank Statements?</h1>
    <Buttons
      isWrapper
      className={uploadType === 'plaid' ? `${s.uploadOption} ${s['uploadOption--selected']}` : s.uploadOption}
      onClick={() => onSelectType('plaid')}
    >
      {uploadType === 'plaid' ? <RadioButton weight="fill" size={16} /> : <Circle size={16} />}
      <div>
        <p className={s.uploadOptionTitle}>
          Connect with Plaid <span className={s.recommendedBadge}>Recommended</span>
        </p>
        <p className={s.uploadOptionDescription}>Securely connect your bank accounts automatically retrieve your bank statements</p>
        <ul className={s.uploadOptionList}>
          <li>
            <CheckCircle weight="fill" size={16} /> Fast and easy set up
          </li>
          <li>
            <CheckCircle weight="fill" size={16} /> Secure, read-only access
          </li>
          <li>
            <CheckCircle weight="fill" size={16} /> Automatically organizes your statements
          </li>
        </ul>
      </div>
    </Buttons>
    <Buttons
      isWrapper
      className={uploadType === 'manual' ? `${s.uploadOption} ${s['uploadOption--selected']}` : s.uploadOption}
      onClick={() => onSelectType('manual')}
    >
      {uploadType === 'manual' ? <RadioButton weight="fill" size={16} /> : <Circle size={16} />}
      <div>
        <div className={s.uploadOptionTitle}>Upload manually</div>
        <div className={s.uploadOptionDescription}>Manually upload bank statements from your computer</div>
        <ul className={s.uploadOptionList}>
          <li>
            <CheckCircle weight="fill" size={16} /> Upload PDF or image files
          </li>
          <li>
            <CheckCircle weight="fill" size={16} /> Works with any bank
          </li>
          <li>
            <CheckCircle weight="fill" size={16} /> No online banking credentials required
          </li>
        </ul>
      </div>
    </Buttons>

    <Button
      variant="primary"
      fullWidth
      size="md"
      onClick={onClickNext}
    >
      Next
    </Button>
  </div>
);

export default ChooseType;